/* eslint-disable react/jsx-key */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import closeIcon from '@Images/icons/icon-close-blue.png';
import {
  Table, Checkbox, Drawer, Select,
} from 'antd';
import UserActions from '@Actions/userActions';
import TenantActions from '@Actions/tenantActions';
import Helpers from '@Apis/helpers';
import { EditFilled } from '@ant-design/icons';
import H3Image from '@Uilib/h3Image';
import H3FormInput from '@Uilib/h3FormInput';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Option } = Select;

class AccessControl extends Component {

  constructor(props) {
    super(props);
    this.state = {

      accessControlTableColumn: [
        {
          title: '',
          render: (text, record) => (<H3Text text={record[0]?.replaceAll('_', ' ')?.toProperCase()} className="org-pending-po__table-text" />),
        },
        {
          title: 'All Access',
          render: (text, record) => (
            <Checkbox
              checked={
                record[1]?.READ
                && record[1]?.CREATE
                && record[1]?.UPDATE
                && record[1]?.DELETE
                && record[1]?.APPROVE
                && record[1]?.UPLOAD
              }
              onChange={(e) => {
                this.handleCheckChangeAll(e, record);
              }}
              //
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
        {
          title: 'Read',
          render: (text, record) => (
            <Checkbox
              checked={record[1]?.READ}
              onChange={(e) => this.handleCheckChange(e, record, 'READ')}
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
        {
          title: 'Write',
          render: (text, record) => (
            <Checkbox
              checked={record[1]?.CREATE}
              onChange={(e) => this.handleCheckChange(e, record, 'CREATE')}
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
        {
          title: 'Update',
          render: (text, record) => (
            <Checkbox
              checked={record[1]?.UPDATE}
              onChange={(e) => this.handleCheckChange(e, record, 'UPDATE')}
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
        {
          title: 'Delete',
          render: (text, record) => (
            <Checkbox
              checked={record[1]?.DELETE}
              onChange={(e) => this.handleCheckChange(e, record, 'DELETE')}
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
        {
          title: 'Approve',
          render: (text, record) => (
            <Checkbox
              checked={record[1]?.APPROVE}
              onChange={(e) => this.handleCheckChange(e, record, 'APPROVE')}
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
        {
          title: 'Upload',
          render: (text, record) => (
            <Checkbox
              checked={record[1]?.UPLOAD}
              onChange={(e) => this.handleCheckChange(e, record, 'UPLOAD')}
              disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.CREATE, this.props.user)}
            />
          ),
        },
      ],
      isUserReady: false,
      typesOfPermissions: ['product', 'inventory_indent', 'vendors', 'purchase_request', 'request_for_quotation', 'purchase_order', 'good_receiving', 'debit_note', 'customer', 'sales_order', 'invoice', 'credit_note', 'customer_payments', 'workflow_setup', 'access_control_setup', 'user_management', 'vendor_payout', 'expenses', 'factory_setup', 'price_list', 'sales_estimate','packing_slip'],
      typesOfRole: ['Admin', 'Finance', 'Purchase', 'Operations', 'Guest', 'Others'],
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.user) {
      props.getTenants(1, '', true, props.user?.tenant_info?.org_id);
      return {
        ...state,
        isUserReady: false,
        user: props.user,
      };
    }
    return state;
  }

  componentDidMount() {
    const { getRoles, user } = this.props;
    getRoles(user?.tenant_info?.tenant_id);
  }

  handleCheckChange(e, record, field) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]][field] = !record[1]?.[field];
    this.setState({ selectedPermissions: copyPermissions });
  }

  handleCheckChangeAll(e, record) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]].READ = e.target.checked;
    copyPermissions[record[0]].CREATE = e.target.checked;
    copyPermissions[record[0]].UPDATE = e.target.checked;
    copyPermissions[record[0]].DELETE = e.target.checked;
    copyPermissions[record[0]].APPROVE = e.target.checked;
    copyPermissions[record[0]].UPLOAD = e.target.checked;
    this.setState({ selectedPermissions: copyPermissions });
  }

  render() {
    const {
      roles, updateRole, user, getRolesLoading,
      updateRoleLoading, getRoles,
    } = this.props;
    const {
      accessControlTableColumn, typesOfPermissions, showPermissions, selectedRole,
      selectedPermissions, typesOfRole,
    } = this.state;
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <div className="ac-wrapper">
          <div className="">
            {typesOfRole?.map((role) => (
              <div className="ac-rollgroup">
                <H3Text text={role} className="ac-role__title" />
                <div className="ac-role__wrapper">
                  {
                    roles?.data?.filter(
                      (tenant) => tenant.tenant_department_name?.toLowerCase()
                        === role?.toLowerCase(),
                    )?.map(
                      (item) => (
                        <div className={`ac-role__roles ${selectedRole?.id == item ? 'ac-role__roles-selected' : ''}`}>
                          <div
                            className="ac-role__role-name__wrapper"
                            onClick={() => {
                              //  getPermissionsSuccess(null);
                              this.setState({
                                showPermissions: true,
                                selectedPermissions: item,
                                //  selectedRole: {
                                //    name: this.getRefactoredRoles().ADMIN[item]?.roleName,
                                //    id: item,
                                //  },
                                permissions: null,
                              });
                              //  getPermissions(1, user?.tenant_info?.tenant_id, item);
                            }}
                          >
                            <H3Text text={item?.tenant_role_name} className="ac-role__role-name" />
                            <div className="ac-role__role-edit">
                              <EditFilled />
                            </div>
                          </div>
                          <H3Text text="Dewa, Himanshu Dewangan" className="ac-role__role-username" />
                        </div>
                      ),
                    )
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
        <Drawer
          placement="right"
          onClose={() => this.setState({ showPermissions: false })}
          open={showPermissions}
          mask={false}
          width="600px"
          destroyOnClose
        >
          <div className="inventory__slider">
            <div className="ac-slider__heading">
              <div className="ac-slider__heading-text">
                Update Role
                {' '}
                <div className="ac-slider__heading-input">
                  <H3FormInput
                    name="Role Name"
                    type="text"
                    containerClassName="orgInputContainer"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    value={selectedPermissions?.tenant_role_name}
                    onChange={(e) => this.setState({
                      selectedPermissions: {
                        ...selectedPermissions,
                        tenant_role_name: e.target.value,
                      },
                    })}
                    label="Role Name"
                    maxlength="100"
                    disabled={updateRoleLoading}
                  />
                  &nbsp;
                  &nbsp;
                  <div className="orgInputContainer">
                    <label className="orgFormLabel">
                      Department Name
                    </label>
                    <PRZSelect
                      className="orgFormSelect"
                      value={selectedPermissions?.tenant_department_name}
                      onChange={(value) => this.setState({
                        selectedPermissions: {
                          ...selectedPermissions,
                          tenant_department_name: value,
                        },
                      })}
                    >
                      {typesOfRole?.map((item) => <Option key={item} value={item}>{item}</Option>)}
                    </PRZSelect>
                  </div>

                </div>

              </div>
              <H3Image
                src={closeIcon}
                className="h3-modal__close-icon"
                onClick={() => {
                  this.setState({ showPermissions: false });
                }}
              />
            </div>
            <div className="generic-table-container">
              <Table
                showHeader
                size="small"
                loading={getRolesLoading || updateRoleLoading}
                pagination={false}
                columns={accessControlTableColumn}
                dataSource={selectedPermissions
                  && Object.entries(selectedPermissions)?.filter(
                    (item) => typesOfPermissions.includes(item[0]),
                  )}
              />
            </div>
          </div>
          {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
            Helpers.permissionTypes.CREATE, user) && (
              <div className="access-control__footer">
                <H3Button
                  text="Update Permissions"
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  disabled={updateRoleLoading}
                  isLoading={updateRoleLoading}
                  customClass="update-access__footer-submit"
                  onClick={() => {
                    updateRole(selectedPermissions, () => {
                      this.setState({ showPermissions: false });
                      getRoles(user?.tenant_info?.tenant_id);
                    });
                  }}
                />
              </div>
            )}
        </Drawer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  roles: UserReducers.roles,
  permissions: UserReducers.permissions,
  getRolesLoading: UserReducers.getRolesLoading,
  updateRoleLoading: UserReducers.updateRoleLoading,
  tenants: TenantReducers.tenants,
});

const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getRoles: (page) => dispatch(UserActions.getRoles(page)),
  updateRole: (payload, callback) => dispatch(
    UserActions.updateRole(payload, callback),
  ),
  getPermissions: (page, tenantId, roleId) => dispatch(
    UserActions.getPermissions(page, tenantId, roleId),
  ),
  getPermissionsSuccess: (permissions) => dispatch(UserActions.getPermissionsSuccess(permissions)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccessControl));
